(function () {
  function initSection(section) {
    const carousel = section.querySelector('[data-infinite-carousel]');
    if (!carousel || carousel.dataset.carouselEnabled === 'false') return;

    if (window.TopInfiniteCarousel) {
      window.TopInfiniteCarousel.init(carousel);
    }

    if (typeof theme !== 'undefined') {
      if (typeof theme.relocateQuickShopModals === 'function') {
        theme.relocateQuickShopModals(section);
      }
      if (typeof theme.reinitProductGridItem === 'function') {
        theme.reinitProductGridItem(section);
      }
    }
  }

  function destroySection(section) {
    const carousel = section.querySelector('[data-infinite-carousel]');
    if (carousel && window.TopInfiniteCarousel) {
      window.TopInfiniteCarousel.destroy(carousel);
    }
  }

  function initAll() {
    document
      .querySelectorAll('[data-section-type="collection-grid"][data-context="featured-collection"], [data-section-type="collection-grid"][data-context="product-recommendations"]')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('recommendations:loaded', (event) => {
    const section = event.detail && event.detail.section;
    if (!section) return;
    const grid = section.querySelector('[data-section-type="collection-grid"][data-context="product-recommendations"]') || section;
    initSection(grid);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector(
      '[data-section-type="collection-grid"][data-context="featured-collection"], [data-section-type="collection-grid"][data-context="product-recommendations"]'
    );
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector(
      '[data-section-type="collection-grid"][data-context="featured-collection"], [data-section-type="collection-grid"][data-context="product-recommendations"]'
    );
    if (section) destroySection(section);
  });
})();
